import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=3e274be6"
import script from "./logo.vue?vue&type=script&setup=true&lang=js"
export * from "./logo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./logo.vue?vue&type=style&index=0&id=3e274be6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports